/**
 * Forms Service Hooks
 * React hooks for accessing Forms Management services.
 */
import { useCCMS } from '../useCCMS';
/** Access all Forms Management services. */
export function useFormsServices() {
    const { services } = useCCMS();
    if (!services?.forms) {
        throw new Error('Forms services not available. Ensure CCMSProvider is configured.');
    }
    return services.forms;
}
export function useFormsService() {
    return useFormsServices().forms;
}
export function useFormCategoriesService() {
    return useFormsServices().formCategories;
}
export function useFormSeriesService() {
    return useFormsServices().formSeries;
}
export function useFormsModuleSettingsService() {
    return useFormsServices().formsModuleSettings;
}
export function useFormEntriesService() {
    return useFormsServices().formEntries;
}
export function useFormWebhooksService() {
    return useFormsServices().formWebhooks;
}
export function usePublicFormsService() {
    return useFormsServices().publicForms;
}
export function useFormsExternalService() {
    return useFormsServices().formsExternal;
}
//# sourceMappingURL=useFormsServices.js.map